import React from "react";
import nl2br from "@/shared/nl2br";

const Top = ({ mainConcept, conceptText, mainConceptImage }) => {
  return (
    <div className="concept-intro background-color--contents_bg ">
      <div className="concept-intro__contents text--center">
        <div className="section-heading">
          <h1 className="section-heading__title color--accent font-family--large">
            MESSAGE
          </h1>
          <p className="section-heading__sub font-family--middle">
            想い・メッセージ
          </p>
        </div>
        <img
          className="concept-intro__img"
          src={mainConceptImage}
          width="600"
          height="450"
          alt={mainConcept}
        />
        <h2 className="concept-intro__title color--accent font-family--middle">
          {nl2br(mainConcept)}
        </h2>
        <p className="text__body color--text">{nl2br(conceptText)}</p>
      </div>
    </div>
  );
};

export default Top;
